<template>
  <div>
    <div>
      <label class="text-base font-bold text-white/75"
        >Features</label
      >
    </div>
    <div class="">
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="sale_type"
          class="checkbox-input"
          v-model="sale_type"
        />
        <span class="checkbox-label">Foreclosure / Short Sale</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="pool"
          class="checkbox-input"
          v-model="pool"
        />
        <span class="checkbox-label">Pool</span>
      </label>
      <label class="form-checkbox group">
        <input
          type="checkbox"
          name="pre_construction"
          class="checkbox-input"
          v-model="pre_construction"
        />
        <span class="checkbox-label">Pre-Construction</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldValue: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      pre_construction: false,
      pool: false,
      sale_type: false
    }
  },

  watch: {
    pre_construction(val){
      this.$emit('updated', {
        property: 'construction_status',
        value: this.pre_construction ? 'To Be Built|Under Construction' : null
      })
    },
    pool(val){
      this.$emit('updated', {
        property: 'pool',
        value: this.pool ? true : false
      })
    },
    sale_type(val){
      this.$emit('updated', {
        property: 'sale_type',
        value: this.sale_type ? 'Short Sale|In Foreclosure|Pre-Foreclosure' : null
      })
    }
  },

  mounted() {
    this.pre_construction = this.fieldValue.construction_status.includes('To Be Built|Under Construction')
    this.pool = this.fieldValue.pool
    this.sale_type = this.fieldValue.sale_type.includes('Short Sale|In Foreclosure|Pre-Foreclosure')
  },
};
</script>
